// Phone Number Validation
// =========
document.addEventListener('DOMContentLoaded', function () {
  const phoneInput = document.querySelector('.phone-number');

  if (!phoneInput || phoneInput.classList.contains('js-validated')) return;
  phoneInput.classList.add('js-validated');
  // Allow + sign
  phoneInput.setAttribute('type', 'text');

  const formatPhone = (value) => {
    value = value.replace(/[^0-9+]/g, '').replace(/(?!^)\+/g, '');

    if (!value.startsWith('+')) {
      return value.replace(/\D/g, '').substring(0, 10);
    }

    const raw = value.replace(/\s/g, '').substring(0, 16);
    const match = raw.match(/^(\+\d{1,3})(\d*)$/);

    return match ? match[1] + (match[2] ? ' ' + match[2] : '') : raw;
  };

  phoneInput.addEventListener('input', function () {
    this.value = formatPhone(this.value);
    this.setCustomValidity('');
  });

  phoneInput.addEventListener('blur', function () {
    const rawValue = this.value.trim().replace(/\s/g, '');
    const isValid = rawValue.startsWith('+') ? /^\+[1-9][0-9]{6,14}$/.test(rawValue) : /^[0-9]{10}$/.test(rawValue);

    this.setCustomValidity(this.value && !isValid ? 'Enter a valid phone number' : '');
    this.reportValidity();
  });
});
